// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import promise from 'es6-promise';
import 'babel-polyfill'

promise.polyfill();

import Vue from 'vue'
import App from './App'

//样式重置
import './assets/css/reset.css'
//公共样式
import './assets/css/common.css'
//动画
import animated from 'animate.css'
//less引入
import less from 'less'

//引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import router from './router'

//视频播放插件
import VideoPlayer from 'vue-video-player'

//引入vuex
import store from './store/index'

Vue.use(ElementUI);
Vue.use(animated)
Vue.use(less);
Vue.use(VideoPlayer);

//引入防止重复点击js
import preventReClick from './util/preventReClick'
Vue.use(preventReClick);
//引入axios
import axios from 'axios';
Vue.prototype.$axios = axios;
//qs引入
import qs from 'qs'
//使用this.$qs获取qs对象
Vue.prototype.$qs = qs;
//引入接口管理
import url from './api/url.js'
Vue.prototype.APIurl = url;
//全局过滤器
import * as filters from './util/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
router.afterEach((to, from, next) => {
  window, scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js